import { z } from "zod";

export const maritalStatusFormSchema = z.object({
  maritalStatusCode: z.string().min(1, "A marital status code is required"),
});
